import { useState } from "react";
import { StatusType } from "../Shared/types/PaymentProcessorTypes";
import { useMediaQuery, useTheme } from "@mui/material";
export const initAcceptCardFormState = {
    status: { type: StatusType.IDLE, message: undefined },
    submitted: false,
    loading: false,
};
/**
 * useAcceptHosted(title) - Manage form and response from Authorize
 * @param {string} title
 * @returns
 */
export const useAcceptHosted = (url) => {
    const [iFrameOpen, setIFrameOpen] = useState(false);
    const [cardFormState, setCardFormState] = useState(initAcceptCardFormState);
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    const AuthorizeNetPostUrl = {
        edit: `${url}/customer/editPayment`,
        add: `${url}/customer/addPayment`,
    };
    const parseResponse = (str) => {
        const values = [];
        const queryStrArr = str.split("&");
        queryStrArr.map((str) => {
            const pair = str.split("=");
            values[pair[0]] = pair[1];
        });
        return values;
    };
    return {
        AuthorizeNetPostUrl,
        cardFormState,
        setCardFormState,
        iFrameOpen,
        setIFrameOpen,
        parseResponse,
        mobile,
    };
};
